import { IConfiguration } from '../interfaces/IConfiguration';
import { CacheExpiryForStoreInHours } from '../appConstants';

export enum GlobalProperties {
  ServerConfiguration = 'serverConfiguration',
  Datasource = 'datasourceId',
}
export const defaultCarAdvisoryAppConfig: IConfiguration = {
  HomePageUrl: '/',
  SearchResultsUrl: '/search-results',
  CarDetailsUrl: '/car-details',
  BasePath: '/',
  ComponentName: '',
  CarComparisonUrl: '/compare-vehicles',
  ExpertReviewsUrl: '/expert-reviews',
  LastUpdated: '',
  NumberOfHoursForStoreContentToExpire: CacheExpiryForStoreInHours,
};
